module.exports = __webpack_public_path__ + "static/media/elephant_top_sobel-min.fd32d365.jpg";